import projectItemImage from "../../assets/icons/projectItem/External.svg";
import infoIcon from "../../assets/icons/projectItem/info.svg";

import { useTranslation } from "react-i18next";
import { useState, useEffect, useRef, Suspense } from "react";

import {animationBlurred, animationScale, jelloScale, descriptionStyle, descriptionStyleOff} from "./ProjectItemStyle"

export default function ProjectItem(props) {
  const daley = props.index * 0.3

  const [projectItemStyle, SetProjectItemStyle] = useState(animationBlurred(daley))
  const [IlustrationStyle, SetIlustrationStyle] = useState(animationScale(daley + 0.27))
  const [TitleIconStyle, SetTitleIconStyle] = useState(animationScale(daley + 0.7))
  const [NameStyle, SetNameStyle] = useState(animationScale(daley + 0.9))
  const [DescriptionStyle, SetDescriptionStyle] = useState({opacity:0})
  const [IsDescriptionOn, SetIsDescriptionOn] = useState(false)
  const [descriptionLabel, SetDescriptionLabel] = useState('show-description')
  const [Time, SetTime] = useState(false)
  const [IsLinkReady, SetIsLinkReady] = useState(false)
    
  const { t } = useTranslation();

  useEffect(() => {
    if(!IsDescriptionOn){
      SetDescriptionStyle(descriptionStyleOff)
      SetDescriptionLabel('show-description')
      setTimeout(() => {
        if(!IsDescriptionOn){
          SetDescriptionStyle({display: 'none'}); 
        }
      }, (0.6) * 1000);
    }else{
      SetDescriptionStyle(descriptionStyle)
      SetDescriptionLabel('hide-description')
    }
  },[IsDescriptionOn])


  function ChangeDescriptionView(){
    
    if(IsDescriptionOn){
      SetIsDescriptionOn(false)
    }else{
      SetIsDescriptionOn(true) 
    }
  }

  useEffect(() => {
    setTimeout(() => {
      SetTime(true);
    }, (daley + 0.6) * 1000);
  },[]);

  function CleanAnimation(){
    if(Time){
      SetProjectItemStyle({})
      SetIlustrationStyle({})
      SetTitleIconStyle({})
      SetNameStyle({})
      SetIsLinkReady(true);
    }
  }

  function OpenProject(){
    if(IsLinkReady){
      window.open(props.link,'_blank');
    }else{
      SetIsLinkReady(true);
    }
  }
  const wrapperRef = useRef(null);
  useOutsideClick(wrapperRef);

  function useOutsideClick(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          SetIsDescriptionOn(false)
          SetIsLinkReady(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }
  
  return (
    <Suspense fallback={<></>}>
      <div className="ProjectItem" ref={wrapperRef} style={projectItemStyle} onMouseOver={CleanAnimation} onMouseLeave={ () => SetIsLinkReady(true)}>
        <div className="Header">
          <div className="Ilustration"style={IlustrationStyle} >
            <img className="Image Static" src={props.img.image} />
            <img className="Image Hover" src={props.img.gif}  onClick={OpenProject} />
          </div>
          <div className="Control">
          
            <a className="buttonControl" style={jelloScale(daley + 1.2)} href={props.link} target="_blank"  >
              <div className="label">
                {t('see-project')}
              </div>
              <img className="Image" src={projectItemImage} alt="link" />
            </a>

            <button className="buttonControl" onClick={ChangeDescriptionView} style={jelloScale(daley + 1.5)}>
              <div className="label">
                {t(descriptionLabel)}
              </div>
              <img className="Image" src={infoIcon} alt="link" />           
            </button>
        
          </div>
        </div>
        <div className="Info">

          <div className="Title">
            <div className="Icon" style={TitleIconStyle}>
              <img className="Image" src={props.img.icon} alt={props.name + " Icon"} />
            </div>
            <span className="Name" style={NameStyle}>
              {props.name}
            </span>
          </div>
        
          <div className="Description" style={DescriptionStyle}>
            <span className="titleDescription"> {t('description')} </span>
            <span className="textDescription">
              {props.description}
              <div className="TagsList">
                {props.tags}
              </div>
            </span>
          </div>
        </div>
      </div>
    </Suspense>
  );
}
